import { styled } from "styled-components";
import { useState } from "react";
import { ReactComponent as SoundEnabledIcon } from "../../assets/svg/soundEnabled.svg";
import { ReactComponent as PageIcon } from "../../assets/svg/page3.svg";
import { ReactComponent as SoundDisabledIcon } from "../../assets/svg/soundDisabled.svg";

import { ReactComponent as FullScreenIcon } from "../../assets/svg/fullScreen.svg";
import { GAudioEngine } from "../../webl/core/audioEngine";
import { GSettings } from "../../webl/core/settings";
import { GHallwaySceneCSS } from "../../webl/scenes/payne/hallway/hallwayCSS";

export const FooterContainer = styled.div`
    background-color: rgba(0, 0, 0, 0);
    width: 300px;
    display: inline-flex;
    justify-content: flex-end;
    padding: 16px;
    align-items: center;
    position: absolute;
    bottom: 0;
    right: 0;
    z-index: 99;
    height: 128px;

    @media (max-width: 1024px) {
        display: none;
    }
`;

export const FooterButtonsContainer = styled.div`
    display: inline-flex;
    align-items: center;
    gap: 2px;
    height: 48px;

    border-radius: 4px;
    background-color: rgba(11, 11, 12, 0.8);
`;

export const IconContainer = styled.div`
    font-family: Rubik;
    align-items: center;
    display: flex;
    justify-content: center;
    width: 48px;
    height: 48px;

    color: #bebebe;

    cursor: pointer;

    &:hover {
        color: #fff;
    }
    //padding: 16px;
`;

export const Divider = styled.div`
    display: inline-flex;
    align-items: center;
    height: 24px;
    width: 2px;

    background-color: #2d2d31;
`;

const SoundIconElement = () => {
    const [isSoundEnabled, setSoundEnabled] = useState(GAudioEngine.isSoundEnabled);

    GAudioEngine.setSoundEnabledFooter = setSoundEnabled;

    return (
        <IconContainer
            onClick={() => {
                //setSoundEnabled(!isSoundEnabled);
                if (GAudioEngine.Instance) {
                    //GAudioEngine.Instance.isSoundEnabled = !GAudioEngine.Instance.isSoundEnabled;
                    GAudioEngine.Instance.toggleSound();
                }
            }}
        >
            {isSoundEnabled && <SoundEnabledIcon />}
            {!isSoundEnabled && <SoundDisabledIcon />}
        </IconContainer>
    );
};

export const CustomIconContainer = styled(IconContainer)<{ $bCurPageOpenedOnce: boolean; $bPageOpen: boolean }>`
    color: ${({ $bCurPageOpenedOnce, $bPageOpen }) =>
        $bPageOpen ? "#c9dfc8" : $bCurPageOpenedOnce ? "#bebebe" : "#9E6F2D"};

    &:hover {
        color: ${({ $bCurPageOpenedOnce, $bPageOpen }) =>
            $bPageOpen ? "#d8f0d7" : $bCurPageOpenedOnce ? "#fff" : "#CCA874"};
    }
`;

const PageElement = () => {
    const [bPageOpen, setPageOpen] = useState(GHallwaySceneCSS.bPageOpen);
    const [bPageOpenOnce, setPageOpenOnce] = useState(false);

    GHallwaySceneCSS.setPageOpenedOnce = setPageOpenOnce;
    GHallwaySceneCSS.setPageOpenFooter = setPageOpen;

    return (
        <CustomIconContainer
            onClick={() => {
                GHallwaySceneCSS.bPageOpen = !GHallwaySceneCSS.bPageOpen;
                GHallwaySceneCSS.setPageOpen(GHallwaySceneCSS.bPageOpen);
                setPageOpen(!bPageOpen);
                setPageOpenOnce(true);
            }}
            $bCurPageOpenedOnce={bPageOpenOnce}
            $bPageOpen={bPageOpen}
        >
            <PageIcon />
        </CustomIconContainer>
    );
};

const QualityContainer: React.FC = () => {
    const [quality, setQuality] = useState<number>(GSettings.EQuality);

    GHallwaySceneCSS.setQualityFooter = setQuality;

    const handleQualityChange = () => {
        const newQuality = (GSettings.EQuality + 1) % 3; // Cycle through 0, 1, 2
        GSettings.EQuality = newQuality; // Update the global quality setting
        GSettings.bQualityChangeThisFrame = true;
        setQuality(newQuality); // Update the local state
    };

    const getQualityLabel = (inquality: number): string => {
        switch (inquality) {
            case 0:
                return "LQ";
            case 1:
                return "MQ";
            case 2:
                return "HQ";
            default:
                return "LQ";
        }
    };

    return <IconContainer onClick={handleQualityChange}>{getQualityLabel(quality)}</IconContainer>;
};

export const FullScreenButton = () => {
    const [isFullScreen, setIsFullScreen] = useState(false);

    const handleFullscreen = () => {
        const element = document.documentElement;
        if (!isFullScreen) {
            element.requestFullscreen();
        } else {
            document.exitFullscreen();
        }
        setIsFullScreen(!isFullScreen);
    };

    return (
        <IconContainer onClick={handleFullscreen}>
            <FullScreenIcon />
        </IconContainer>
    );
};

export const Footer = () => {
    return (
        <>
            <FooterContainer>
                <FooterButtonsContainer>
                    <PageElement />
                    <Divider />
                    <SoundIconElement />
                    <Divider />
                    {/* <FullScreenButton /> */}
                    {/* <Divider /> */}
                    <QualityContainer />
                </FooterButtonsContainer>
            </FooterContainer>
        </>
    );
};
